<div class="auth-sub-component">
  <nz-alert nzType="error"
            [nzMessage]=message style="margin-bottom: 10%">
    <ng-template #message>
    <span class="font-icon-color-exclude-group">You have been locked out due to multiple
    unsuccessful login attempts.
    Try again in {{minutesTillBlockingFinish}} minutes ({{timeBlockingFinish}}).</span>
    </ng-template>
  </nz-alert>
  <ng-template #prefixUser><em nz-icon nzType="user"></em></ng-template>
  <ng-template #prefixLock><em nz-icon nzType="lock"></em></ng-template>
</div>
